/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Select_Guide_PromptInputs */

const en_knp_lookup_select_guide_prompt = /** @type {(inputs: Knp_Lookup_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a KNP guide to view terms.`)
};

const fr_knp_lookup_select_guide_prompt = /** @type {(inputs: Knp_Lookup_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner un guide KNP pour afficher les termes.`)
};

const de_knp_lookup_select_guide_prompt = /** @type {(inputs: Knp_Lookup_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie einen KNP-Guide aus, um die Bedingungen anzuzeigen.`)
};

const it_knp_lookup_select_guide_prompt = /** @type {(inputs: Knp_Lookup_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezionare una guida KNP per visualizzare i termini.`)
};

const ru_knp_lookup_select_guide_prompt = /** @type {(inputs: Knp_Lookup_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите гида КНП, чтобы просмотреть условия.`)
};

const es_knp_lookup_select_guide_prompt = /** @type {(inputs: Knp_Lookup_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione una guía KNP para ver los términos.`)
};

const zh_cn2_knp_lookup_select_guide_prompt = /** @type {(inputs: Knp_Lookup_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择一位克鲁格国家公园导游查看条款。`)
};

const ja_knp_lookup_select_guide_prompt = /** @type {(inputs: Knp_Lookup_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`条件を表示するには、KNP ガイドを選択してください。`)
};

const hi_knp_lookup_select_guide_prompt = /** @type {(inputs: Knp_Lookup_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नियम और शर्तें देखने के लिए कृपया केएनपी गाइड का चयन करें।`)
};

const pt_pt2_knp_lookup_select_guide_prompt = /** @type {(inputs: Knp_Lookup_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um guia do KNP para visualizar os termos.`)
};

/**
* | output |
* | --- |
* | "Please select a KNP guide to view terms." |
*
* @param {Knp_Lookup_Select_Guide_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_select_guide_prompt = /** @type {((inputs?: Knp_Lookup_Select_Guide_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Select_Guide_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_select_guide_prompt(inputs)
	if (locale === "de") return de_knp_lookup_select_guide_prompt(inputs)
	if (locale === "it") return it_knp_lookup_select_guide_prompt(inputs)
	if (locale === "ru") return ru_knp_lookup_select_guide_prompt(inputs)
	if (locale === "es") return es_knp_lookup_select_guide_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_select_guide_prompt(inputs)
	if (locale === "ja") return ja_knp_lookup_select_guide_prompt(inputs)
	if (locale === "hi") return hi_knp_lookup_select_guide_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_select_guide_prompt(inputs)
	return en_knp_lookup_select_guide_prompt(inputs)
});